import Button from '@mui/material/Button';
import i18next from 'i18next';

import * as S from './styles';

interface ErrorFallbackProps {
  error: Error;
  onReset: () => void;
}

/**
 * Language is resolved from a small local map rather than the i18n resource tree:
 * an error fallback must stay readable even if translation loading is itself broken.
 */
const COPY = {
  de: {
    title: 'Etwas ist schiefgelaufen',
    description: 'Beim Laden dieses Bereichs ist ein unerwarteter Fehler aufgetreten.',
    retry: 'Erneut versuchen',
    reload: 'Seite neu laden',
  },
  en: {
    title: 'Something went wrong',
    description: 'An unexpected error occurred while loading this area.',
    retry: 'Try again',
    reload: 'Reload page',
  },
} as const;

const ErrorFallback = ({ error, onReset }: ErrorFallbackProps) => {
  const lang = (i18next.language || 'de').startsWith('en') ? 'en' : 'de';
  const copy = COPY[lang];

  return (
    <S.Root role='alert'>
      <S.Title>{copy.title}</S.Title>
      <S.Description>{copy.description}</S.Description>
      {process.env.NODE_ENV !== 'production' && error?.message && (
        <S.Details>{error.message}</S.Details>
      )}
      <S.Actions>
        <Button variant='outlined' onClick={onReset}>
          {copy.retry}
        </Button>
        <Button variant='contained' onClick={() => window.location.reload()}>
          {copy.reload}
        </Button>
      </S.Actions>
    </S.Root>
  );
};

export default ErrorFallback;
